import { useEffect, useState } from 'react';
import logo from '../../images/LOGO_FIT.png'
import InputValidate from '../../components/InputValidate';
import { Button } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import AxiosClient from '../../api/AxiosClient';
import UtilFunctions from '../../Utils/UtilFucntion';
export default function ForgotPassword() {
    const [password, setPassword] = useState<string>('');
    const [confirm, setConfirm] = useState<string>('');
    const [param, setParam] = useSearchParams();

    function onChangeData(name: string, value: string): void {
        setPassword(value);
    }

    function onChangeDataConfirm(name: string, value: string): void {
        setConfirm(value)
    }

    function submit(): void {
        AxiosClient.post('reset-password', {
            token: param.get('token'),
            password: password,
            password_confirmation: confirm
        }).then(() => {
            UtilFunctions.showToastSuccess('Đổi mật khẩu thành công!');
            setTimeout(() => {
                window.location.href = '/login'
            }, 500);
        }).catch((e) => {
            console.log(e);
        })
    }

    return (
        <div className="login-page">
            <div className="login-main">
                <div className="login-logo">
                    <div className="login-logo--image">
                        <img src={logo} alt="Logo" />
                    </div>
                </div>
                <div className="login-title">
                    <div className="login-title--title">Khôi phục mật khẩu</div>
                    <div className="login-title--description">Nhập mật khẩu vào biểu mẫu bên dưới</div>
                </div>
                <div className='mt-10 flex flex-col gap-8'>
                    <InputValidate label={'Mật khẩu mới'} name={'password'} onChangeData={onChangeData} value={password} isValid={password.length >= 8} alert={'Mật khẩu phải dài hơn 8 ký tự'} disabled={false} placeholder={'Mật khẩu mới'} type={'password'} />
                    <InputValidate label={'Xác nhận mật khẩu mới'} name={'password'} onChangeData={onChangeDataConfirm} value={confirm} isValid={confirm === password} alert={'Mật khẩu không khớp'} disabled={false} placeholder={'Xác nhận mật khẩu'} type={'password'} />
                </div>
                <div className='mt-4 w-full flex justify-end'>
                    <Button variant='contained' onClick={submit}>Đổi mật khẩu</Button>
                </div>
            </div>
        </div>
    )
}